import { styled } from 'next-yak';

import { createPolymorphicElement } from '@xing-com/polymorphic-element';
import { spaceS } from '@xing-com/tokens';

// *** Components ***
const ContainerElement = createPolymorphicElement('div');

export const Container = styled(ContainerElement)`
  display: flex;
  gap: ${spaceS};
  flex-shrink: 0;
`;
